import HttpClient from "@/services/HttpClient";
import { EServices } from "@/types";
import { inject, injectable } from "tsyringe";
import { IActivity, ISecurityClient } from "../types";
import StoreService from "@/store";

@injectable()
export default class SecurityClient implements ISecurityClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async getActivities(): Promise<IActivity[]> {
    const response = await this.http.get("/v1/app/activities");
    this.store.commit("SecurityModule/setActivities", response.data);
    return response.data;
  }
}
